module.exports = __webpack_public_path__ + "img/floor1.c735878d.jpg";